import { Box, styled } from '@mui/material';

export const LanguageCounterBadgeBox = styled(Box)({
  backgroundColor: '#FFF5D8',
  borderRadius: '4px',
  padding: '2px 6px',
  fontSize: '0.75rem',
  fontWeight: 500,
  color: '#B28510',
  display: 'flex',
  alignItems: 'center'
});